<template>
    <div class="flex-1 flex flex-col items-center justify-center text-center py-20">
        <div class="text-(--color-brand-600) mb-6">
            <slot name="icon">
                <InlineSvg :src="`/icons/${icon}.svg`" />
            </slot>
        </div>
        <p class="font-medium mb-2 text-gray-800 text-center">
            <slot name="title">
                There is nothing to see here right now.
            </slot>
        </p>

        <p class="text-sm text-gray-700 text-center flex flex-col items-center">
            <slot name="subtitle">
                Please come back at a later time.
            </slot>
        </p>
    </div>
</template>

<script setup>
    import InlineSvg from 'vue-inline-svg'

    const props = defineProps({
        icon: {
            type: String,
            default: 'empty',
        },
        config: Object,
    })
</script>
